/**
 * @fileoverview ESM view of the ONE locale-keyed `Intl` formatter cache.
 * @module @puffin-core/i18n-bootstrap/esm/formatterCache
 *
 * **There is no logic in this file.** The implementation lives once, in CJS, at
 * `../formatterCache.js`; this re-exports it so ESM consumers (every web app,
 * palm-native, page-shell) keep importing exactly what they imported before.
 *
 * ES-I18N-FOLLOW-ON Lane A2 (2026-08-02) inverted the source direction so the
 * CommonJS API tier can `require()` the cache — `@puffin-core/money`'s
 * `formatUsd` is one line over `getNumberFormatter`, and the API tier needs
 * `formatUsd` for outbound customer email and its report builders. See
 * `../formatterCache.js` for the full rationale, including why only this leaf is
 * dual and the barrel deliberately is not.
 *
 * ## Why a destructured DEFAULT import and not `export { x } from …`
 *
 * `export { getNumberFormatter } from '../formatterCache.js'` is a STATIC named
 * import, and bundlers cannot always see through a CJS `module.exports` to
 * satisfy one — `@puffin-tooling/esm-build`'s generator documents this exact trap
 * (it is why `route-match`'s mirror was hand-written). Destructuring a default
 * import is a RUNTIME read, so it works wherever CJS interop works, which is the
 * form the generator emits for all 21 generated packages.
 */

import formatterCache from '../formatterCache.js';

export const {
  roundAsDisplayed,
  getNumberFormatter,
  getDateTimeFormatter,
  getRelativeTimeFormatter,
  getListFormatter,
  getPluralRules,
  __resetFormatterCacheForTests,
} = formatterCache;
